export default {
    required: 'Kenttä on pakollinen',
    minLength: 'Kentän tulee sisältää vähintään {min} merkkiä',
    maxLength: 'Kenttä saa sisältää maksimissaan {max} merkkiä',
    integer: 'Kenttä saa sisältää vain numeroita',
    email: 'Sähköpostiosoite ei ole oikean muotoinen',
    terms: 'Käyttöehdot tulee hyväksyä',
    login_failed: 'Käyttäjätunnus tai salasana on väärin. Jos olet unohtanut salasanasi, voit resetoida sen alla olevasta linkistä.'
}